import { Grid } from '@mui/material';
import { ReactNode } from 'react';
import { SxProps, Theme } from '@mui/material/styles';

type TemplateDetailsProps = {
  title?: string;
  children: ReactNode;
  testid?: string;
  titleExtraClass?: SxProps<Theme>;
};

export default function TemplateDetails({
  testid,
  children,
  title,
  titleExtraClass = [],
}: TemplateDetailsProps) {
  return (
    <Grid item mb={4} data-testid={testid}>
      <h5 style={{ margin: 0, fontSize: '13px' }} data-testid="template-title">
        {title}
      </h5>
      {children}
    </Grid>
  );
}
